<template>
  <footer v-if="isFooterEnabled" class="app-footer">
    <div class="footer-content">
      <div class="links" role="navigation" aria-label="Footer">
        <router-link to="/features" class="footer-link">Features</router-link>
        <span v-if="featuresStore.isWhatsNewEnabled" class="dot" aria-hidden="true">·</span>
        <router-link v-if="featuresStore.isWhatsNewEnabled" to="/whats-new" class="footer-link">What's New</router-link>
        <span class="dot" aria-hidden="true">·</span>
        <router-link to="/about" class="footer-link">About</router-link>
        <span class="dot" aria-hidden="true">·</span>
        <router-link to="/feedback" class="footer-link">Contact Us</router-link>
        <span v-if="!featuresStore.isTermsAndConditionsDisabled" class="dot" aria-hidden="true">·</span>
        <router-link v-if="!featuresStore.isTermsAndConditionsDisabled" to="/terms" class="footer-link">T&Cs</router-link>
      </div>
      <router-link to="/about" class="copyright" aria-label="About GRAP">© {{ year }} GRAP Platform</router-link>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useFeaturesStore } from '../stores/features'

// Hardcoded feature flag - set to true to enable footer
const isFooterEnabled = false

const year = ref(new Date().getFullYear())
const featuresStore = useFeaturesStore()
</script>

<style scoped>
.app-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 15, 14, 0.9);
  border-top: 1px solid var(--border-color);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 900;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.6rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.footer-content::-webkit-scrollbar {
  height: 4px;
}

.footer-content::-webkit-scrollbar-track {
  background: transparent;
}

.footer-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

.links { 
  display: flex; 
  gap: 0.5rem; 
  align-items: center; 
  flex-wrap: nowrap; 
  white-space: nowrap;
}

.footer-link { 
  color: var(--text-secondary); 
  text-decoration: none; 
  font-size: 0.9rem; 
  white-space: nowrap; 
  flex-shrink: 0;
}

.footer-link:hover {
  color: var(--text-color);
}

.dot { color: var(--border-hover); }

.copyright {
  color: var(--text-secondary);
  font-size: 0.85rem;
  flex-shrink: 0;
  white-space: nowrap;
}

@media (max-width: 768px) {
  /* Mobile: keep footer fixed just above the bottom tab bar */
  .app-footer {
    position: fixed;
    bottom: 0; /* stick to very bottom */
    padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 8px);
  }

  .footer-content {
    padding: 0.35rem 0.75rem; /* lower, slimmer on phones */
    flex-direction: row; /* Keep horizontal layout */
    gap: 0.25rem;
    align-items: center;
  }

  .links { gap: 0.35rem 0.6rem; display: flex; } /* show links on phones */
  .dot { display: none; }
  .footer-link { font-size: 0.95rem; }
  .copyright { 
    display: none; 
    flex-shrink: 0;
  }
}

@media (max-width: 480px) {
  .app-footer { bottom: 0; padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 4px); }
}
</style>


